/**
 * Identifiant visiteur `_fvid` — Phase 6.R.5 (D-RGPD-3, exemption « mesure d'audience »).
 *
 * `_fvid` distingue les visiteurs anonymes des tunnels (funnel_events). Pour
 * rester dans l'exemption CNIL de consentement, sa durée de vie doit être
 * **plafonnée à 13 mois** — au-delà, l'ancien identifiant est oublié et un
 * nouveau est généré (le visiteur redevient « neuf »).
 *
 * localStorage n'a pas d'expiration native : on stocke un timestamp de création
 * à côté de l'id, et on régénère si l'âge dépasse 13 mois.
 *
 * ⚠️ Source UNIQUE : avant 6.R.5, cette fonction était dupliquée inline dans 2
 * pages SSR (funnels.ts) + webinar-room.js, SANS borne d'expiration. Centralisée
 * ici et exposée en global (comme escape.js / video-embed.js) ; chargée par
 * <script src> ('self', compatible CSP) sur les pages funnel SSR.
 */
(function () {
  var KEY = '_fvid';
  var TS_KEY = '_fvid_ts';
  var OPTOUT_KEY = '_fvid_optout';
  // 13 mois (borne CNIL). Approximé en jours : 13 × 30,5 ≈ 396,5 jours.
  var MAX_AGE_MS = Math.round(396.5 * 24 * 60 * 60 * 1000);

  function ephemeral() {
    return 'v' + Date.now().toString(36) + Math.random().toString(36).slice(2, 10);
  }

  function fvid() {
    var id, ts;
    try {
      // Opt-out de la mesure d'audience (bouton dans la politique de
      // confidentialité, 6.R.5) : id ÉPHÉMÈRE non persisté → le visiteur n'est
      // plus suivi d'une page à l'autre.
      if (localStorage.getItem(OPTOUT_KEY) === '1') return ephemeral();
      id = localStorage.getItem(KEY);
      ts = parseInt(localStorage.getItem(TS_KEY) || '0', 10);
    } catch (e) {
      // localStorage indisponible (mode privé strict) : id éphémère de session.
      return ephemeral();
    }
    var now = Date.now();
    if (!id || !ts || now - ts > MAX_AGE_MS) {
      id = ephemeral();
      try {
        localStorage.setItem(KEY, id);
        localStorage.setItem(TS_KEY, String(now));
      } catch (e) {
        /* écriture impossible : on renvoie l'id éphémère quand même */
      }
    }
    return id;
  }

  // État / bascule de l'opt-out (consommés par la page politique de confidentialité).
  fvid.isOptedOut = function () {
    try {
      return localStorage.getItem(OPTOUT_KEY) === '1';
    } catch (e) {
      return false;
    }
  };
  fvid.setOptOut = /** @param {boolean} on */ function (on) {
    try {
      if (on) {
        localStorage.setItem(OPTOUT_KEY, '1');
        // Oublie l'identifiant existant : plus aucun suivi persistant.
        localStorage.removeItem(KEY);
        localStorage.removeItem(TS_KEY);
      } else {
        localStorage.removeItem(OPTOUT_KEY);
      }
    } catch (e) {
      /* localStorage indisponible : rien à faire */
    }
  };

  window._fvid = fvid;
})();

;
/**
 * EduSaas — Page Classement (Leaderboard)
 */
window.Pages = window.Pages || {};

Pages.leaderboard = async function (params) {
  App.updateNav();
  App.render('<div class="loader"><div class="loader__spinner"></div></div>');

  try {
    const programId = params.id;
    const data = await API.get(`/gamification/leaderboard/${programId}`);
    const { leaderboard, userRank } = data;

    // Charge le nom du programme
    const progData = await API.get(`/programs/${programId}`);
    const programTitle = progData.program.title;

    let html = '<div class="page">';
    html += `
      <a href="#/programme/${programId}" class="lesson-header__back"><i class="ph ph-arrow-left"></i> ${esc(programTitle)}</a>
      <div class="page__header">
        <h2 class="page__title"><i class="ph ph-trophy"></i> Classement</h2>
      </div>`;

    if (leaderboard.length === 0) {
      html += `
        <div style="text-align:center;padding:var(--space-2xl) 0">
          <div class="empty-state__icon"><i class="ph ph-trophy"></i></div>
          <p class="text-muted">Aucun participant pour le moment.</p>
        </div>`;
    } else {
      // Podium (top 3)
      for (let i = 0; i < leaderboard.length; i++) {
        const l = leaderboard[i];
        const rank = i + 1;
        const isMe = l.user_id === App.user.id;
        const initial = (l.display_name || '?')[0].toUpperCase();
        const rankCls = rank <= 3 ? ` leaderboard__rank--${rank}` : '';
        const rowCls = isMe ? ' leaderboard__row--me' : '';

        html += `
          <div class="leaderboard__row${rowCls}">
            <div class="leaderboard__rank${rankCls}">${rank}</div>
            <div class="leaderboard__avatar">${initial}</div>
            <div class="leaderboard__info">
              <div class="leaderboard__name">${esc(l.display_name)}${isMe ? ' (vous)' : ''}</div>
              ${l.streak_days > 1 ? `<div class="leaderboard__streak"><i class="ph ph-flame"></i> ${l.streak_days}j</div>` : ''}
            </div>
            <div>
              <div class="leaderboard__xp">${l.total_xp}</div>
              <div class="leaderboard__xp-label">XP</div>
            </div>
          </div>`;
      }
    }

    // Position de l'utilisateur si pas dans le top visible
    if (userRank && !leaderboard.some((l) => l.user_id === App.user.id)) {
      html += `
        <div class="leaderboard__user-sticky">
          <div class="leaderboard__row leaderboard__row--me">
            <div class="leaderboard__rank">${userRank.rank}</div>
            <div class="leaderboard__avatar">${(App.user.display_name || '?')[0].toUpperCase()}</div>
            <div class="leaderboard__info">
              <div class="leaderboard__name">${esc(App.user.display_name)} (vous)</div>
            </div>
            <div>
              <div class="leaderboard__xp">${userRank.total_xp}</div>
              <div class="leaderboard__xp-label">XP</div>
            </div>
          </div>
        </div>`;
    }

    html += '</div>';
    App.render(html);
  } catch (err) {
    App.render(`<div class="page page--center"><p class="text-error">${err.message}</p></div>`);
  }
};

;
/**
 * EduSaas — Page Journal de bord
 * Vue globale + vue par formation
 */
window.Pages = window.Pages || {};

Pages.journal = async function (params) {
  App.updateNav();
  App.render('<div class="loader"><div class="loader__spinner"></div></div>');

  try {
    const dashData = await API.get('/programs/me/dashboard');
    const { enrollments } = dashData;

    // null = vue globale, Number = vue programme
    const programId = params.program_id || null;

    const journalData = programId
      ? await API.get(`/gamification/journal?program_id=${programId}`)
      : await API.get('/gamification/journal');
    const entries = journalData.entries;

    const moods = [
      { value: 'great', icon: 'ph-smiley-wink', color: '#27ae60' },
      { value: 'good', icon: 'ph-smiley', color: '#2ecc71' },
      { value: 'neutral', icon: 'ph-smiley-meh', color: '#f39c12' },
      { value: 'struggling', icon: 'ph-smiley-sad', color: '#e67e22' },
      { value: 'stuck', icon: 'ph-smiley-nervous', color: '#e74c3c' },
    ];

    let html = '<div class="page">';
    html += `
      <div class="page__header">
        <h2 class="page__title">${t('journal.title')}</h2>
      </div>`;

    // Sélecteur : Global + formations
    if (enrollments.length > 0) {
      html += '<div class="community-program-select" style="margin-bottom:var(--space-md)">';
      html += `<a href="#/journal" class="community-chip${!programId ? ' community-chip--active' : ''}">${t('journal.global')}</a>`;
      for (const e of enrollments) {
        const active = e.program_id === programId ? ' community-chip--active' : '';
        html += `<a href="#/journal?program_id=${e.program_id}" class="community-chip${active}">${esc(e.title)}</a>`;
      }
      html += '</div>';
    }

    // ── Formulaire ──
    html += `
      <div class="journal-form">
        <div class="journal-form__moods">
          ${moods.map((m) => `<button class="journal-form__mood" data-mood="${m.value}" title="${m.value}"><i class="ph ${m.icon}"></i></button>`).join('')}
        </div>
        <textarea class="form__input" id="journal-input" rows="3" placeholder="${t('journal.default_placeholder')}"></textarea>
        <button class="btn btn--primary btn--full" id="journal-submit" style="margin-top:var(--space-sm)">${t('journal.submit')}</button>
      </div>`;

    // ── Entrées groupées par date (tableau compact) ──
    if (entries.length === 0) {
      html += `
        <div style="text-align:center;padding:var(--space-xl) 0">
          <p class="text-muted">${t('journal.empty')}</p>
        </div>`;
    } else {
      html += '<div class="journal-table">';
      let currentDate = '';

      for (const entry of entries) {
        // SQLite datetime('now') → "2026-02-25 11:24:37", handle both T and space
        const raw = entry.created_at.replace(' ', 'T');
        const entryDate = raw.split('T')[0];
        const dateObj = new Date(entryDate + 'T00:00:00Z');
        const day = dateObj.getUTCDate();
        const monthShort = dateObj.toLocaleDateString(I18n.locale === 'en' ? 'en-US' : 'fr-FR', {
          month: 'short',
          timeZone: 'UTC',
        });
        const showDate = entryDate !== currentDate;
        if (showDate) currentDate = entryDate;

        const moodObj = moods.find((m) => m.value === entry.mood);
        const moodIcon = moodObj
          ? `<i class="ph ${moodObj.icon}" style="color:${moodObj.color}"></i>`
          : '<i class="ph ph-pen-nib"></i>';
        const programLabel = entry.program_title ? esc(entry.program_title) : t('journal.personal');

        html += `
          <div class="journal-row${showDate ? '' : ' journal-row--same-day'}">
            <div class="journal-row__date">
              ${showDate ? `<i class="ph ph-calendar-blank"></i><span>${day} ${monthShort}</span>` : ''}
            </div>
            <div class="journal-row__mood">${moodIcon}</div>
            <div class="journal-row__content">
              <div class="journal-row__program">${programLabel}</div>
              <div class="journal-row__text">${esc(entry.content)}</div>
            </div>
          </div>`;
      }
      html += '</div>';
    }

    html += '</div>';
    App.render(html);

    // ── Handlers ──
    let selectedMood = null;

    document.querySelectorAll('.journal-form__mood').forEach((btn) => {
      btn.addEventListener('click', () => {
        document
          .querySelectorAll('.journal-form__mood')
          .forEach((b) => b.classList.remove('journal-form__mood--selected'));
        btn.classList.add('journal-form__mood--selected');
        selectedMood = btn.dataset.mood;
      });
    });

    document.getElementById('journal-submit')?.addEventListener('click', async () => {
      const input = document.getElementById('journal-input');
      if (!input || !input.value.trim()) {
        App.toast(t('journal.write_something'), 'warning');
        return;
      }
      try {
        await API.post('/gamification/journal', {
          program_id: programId || null,
          content: input.value.trim(),
          mood: selectedMood,
        });
        App.toast(t('journal.entry_added'), 'success');
        Pages.journal(programId ? { program_id: programId } : {});
      } catch (err) {
        App.toast(err.message, 'error');
      }
    });
  } catch (err) {
    App.render(`<div class="page page--center"><p class="text-error">${err.message}</p></div>`);
  }
};
